import { Alert as MantineAlert } from '@mantine/core'
import { FunctionComponent, PropsWithChildren } from 'react'
import { WithClassName } from '../types/utils'
import { Icon, IconName, IconSize } from './Icon'

type AlertVariant = 'primary' | 'secondary' | 'tertiary' | 'warning' | 'danger'

const variantToColor: Record<AlertVariant, string> = {
  primary: 'king',
  secondary: 'platinum',
  tertiary: 'cobalt',
  warning: 'warning',
  danger: 'alert',
}

type Props = {
  variant: AlertVariant
  title?: string
  iconName?: IconName
  iconSize?: IconSize
}

export const Alert: FunctionComponent<PropsWithChildren<Props & WithClassName>> = ({ className, variant, title, iconName, iconSize = 'sm', children }) => (
  <MantineAlert className={className} color={variantToColor[variant]} title={title} icon={iconName ? <Icon name={iconName} size={iconSize} className="**:fill-current" /> : undefined}>
    {children}
  </MantineAlert>
)
